const XL3 = 48

export default {
  sizes: {
    '3xl': {
      container: {
        width: XL3,
        height: XL3,
        fontSize: XL3 / 2.5,
      },
      excessLabel: {
        width: XL3,
        height: XL3,
      },
      label: {
        fontSize: XL3 / 2.5,
      },
    },
  },
}
